import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './index.module.scss'

interface IActions {
  fastActions: any[]
  fastActionSelected: any
  onFastActionSelected: any
  translations: any
}
const FastActions: React.FC<IActions> = ({ fastActions, translations, fastActionSelected, onFastActionSelected }) => {
  return (
    <Dropdown
      className={`rankmiTable-fastActions-container ml-2 ${styles.fastActionsSelect} ${fastActionSelected ? styles.active : ''} m-0`}
      overlay={
        <Menu>
          <Menu.Item onClick={() => onFastActionSelected(0)}>
            {translations.header.allParticipants} {fastActionSelected === 0 ? <FontAwesomeIcon icon={faCheck} /> : <div className={styles.fastActionOffset} />}
          </Menu.Item>
          {fastActions.map(({ label, value, group, disabled: disabledRoot }, indexGroup) =>
            group && group.length ? (
              <Menu.ItemGroup key={`fastActionGroup-${indexGroup}`} title={label}>
                {group.map(({ label, value, disabled = disabledRoot }: any, index: number) => (
                  <Menu.Item disabled={disabled} key={`fastAction-${indexGroup}-${index}`} onClick={() => onFastActionSelected(value)}>
                    {label}
                    {fastActionSelected === value ? <FontAwesomeIcon icon={faCheck} /> : <div className={styles.fastActionOffset} />}
                  </Menu.Item>
                ))}
              </Menu.ItemGroup>
            ) : (
              <Menu.Item disabled={disabledRoot} key={`action-${indexGroup}`} onClick={() => onFastActionSelected(value)}>
                {label}
                {fastActionSelected === value ? <FontAwesomeIcon icon={faCheck} /> : <div className={styles.fastActionOffset} />}
              </Menu.Item>
            )
          )}
        </Menu>
      }
      overlayClassName="rankmiTable-fastActions"
      placement="bottomRight"
    >
      <Button size="small">
        <FontAwesomeIcon icon={faList} />
      </Button>
    </Dropdown>
  )
}

export default FastActions
